export default class FilterCondition {
    value = null;

    values = null;

    min = null;

    max = null;

    constructor({
        value = null, values = null, min = null, max = null,
    } = {}) {
        this.value = value;
        this.values = values;
        this.min = min;
        this.max = max;
    }
}
